import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { getOnEnter } from '../../_utils';
import { Icon, IconColor, IconID, IconSize } from '../../icon';
import { RoutedLink } from '../../link';
import { Typography } from '../../typography';
import styles from '../accordion.module.scss';
import { renderAccordionIcon } from '../accordion-icon-util';
import { renderAccordionActionButtons } from '../accordion-util';
export var AccordionListVariant;
(function (AccordionListVariant) {
    AccordionListVariant["SINGLE_SELECT"] = "singleSelect";
    AccordionListVariant["MULTI_SELECT"] = "multiSelect";
})(AccordionListVariant || (AccordionListVariant = {}));
export const AccordionList = ({ listData, variant = AccordionListVariant.SINGLE_SELECT, activeItemIndex, checkedItemIndexes = [], disabledItemIndexes = [], disabledItemReasons = [], onClick = _.noop, linkBuilder, className = '', checkedIcon, ...restProps }) => {
    const handleListItemClick = (event, index, listItem) => {
        event.stopPropagation();
        if (disabledItemIndexes.includes(index)) {
            return;
        }
        onClick(listItem.id, index, event);
    };
    const renderCheckmarkIcon = () => {
        return (React.createElement(Icon, { id: checkedIcon || IconID.CHECKMARK, className: styles.checkMarkIcon, color: IconColor.BLUE, size: IconSize.SMALL }));
    };
    const renderCustomContent = (listItem) => {
        return listItem.customContent;
    };
    return (React.createElement("div", { ...restProps, role: "tablist" }, listData.map((listItem, index) => {
        const { id, label, actionButtons, actionButtonsAlwaysVisible, actionIcon, customContent, } = listItem;
        const isChecked = checkedItemIndexes.includes(index);
        const isDisabled = disabledItemIndexes.includes(index);
        const position = isDisabled
            ? disabledItemIndexes.indexOf(index)
            : 0;
        const commonProps = {
            key: id,
            id,
            className: cx(className, styles.listItem, {
                [styles.listItemActive]: activeItemIndex === index,
                [styles.listItemDisabled]: isDisabled,
            }),
            tabIndex: 0,
            role: 'tab',
            onClick: (event) => handleListItemClick(event, index, listItem),
            onKeyDown: getOnEnter((event) => handleListItemClick(event, index, listItem)),
            'data-tooltip-content': isDisabled
                ? disabledItemReasons[position]
                : '',
            'aria-label': listItem.ariaLabel || listItem.label,
            'aria-selected': activeItemIndex === index,
        };
        const listItemContent = (React.createElement(React.Fragment, null,
            variant === AccordionListVariant.MULTI_SELECT &&
                isChecked &&
                renderCheckmarkIcon(),
            label && (React.createElement("div", { className: styles.listItemText },
                React.createElement(Typography, { variant: "p", overrideTag: "div", className: cx({
                        [styles.listItemActiveText]: activeItemIndex === index,
                    }), ellipsis: { rows: 1 }, noMargin: true }, label))),
            !isDisabled &&
                renderAccordionActionButtons(actionButtons, actionButtonsAlwaysVisible),
            !isDisabled &&
                actionIcon &&
                renderAccordionIcon(actionIcon),
            customContent && renderCustomContent(listItem)));
        return linkBuilder ? (React.createElement(RoutedLink, { href: linkBuilder(listItem.id), noUderline: true, ...commonProps }, listItemContent)) : (React.createElement("div", { ...commonProps }, listItemContent));
    })));
};
//# sourceMappingURL=accordion-list.js.map